<template>
  <fieldset>
    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">URL (https://..)</div>
      </div>
      <input type="url" class="form-control" required pattern="https://.+" v-model="url" @input="onUpdate">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const url = ref(null);
const serializedValue = computed(() => {
  return {
    url: url.value
  };
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    url.value = modelValue.value.url;
  }
}, {
  immediate: true
});
</script>
